






































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { FormValues, QuickTip } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInputRadio from "@/components/BaseInputRadio";
import QuickTipsItem from "@/components/QuickTipsItem";
import { TaxFormDraft, TinType } from "../../../types";
import { tinOptions, tinPatterns } from "../taxFormConfig";

export default defineComponent({
  name: "TinForm",
  components: { BaseForm, BaseInputRadio, QuickTipsItem },
  props: {
    draft: { type: Object as PropType<TaxFormDraft | null>, default: null },
  },
  setup(props, { emit }) {
    const tinType = ref<TinType | null>(props.draft?.tinType ?? null);
    const values = ref<FormValues>({ taxId: props.draft?.taxId ?? "" });
    const formValid = ref(false);
    const tipItem: QuickTip = { icon: "msr-info", type: "secondary" };

    const fields = computed(() => {
      if (!tinType.value) return [];
      return [
        {
          name: "taxId",
          label: $t("TAX ID #"),
          rules: { required: true, regex: tinPatterns[tinType.value] },
          rulesMessages: { regex: $t("Enter a valid {0} number", [tinType.value]) },
          validationMode: "aggressive",
        },
      ];
    });

    const emitState = () => {
      emit("updateDraft", { tinType: tinType.value ?? undefined, taxId: values.value.taxId as string });
      emit("setValid", !!tinType.value && formValid.value && !!values.value.taxId);
    };

    const onTinTypeInput = (value: TinType) => {
      tinType.value = value;
      emitState();
    };

    const onFormValidation = (valid: boolean) => {
      formValid.value = valid;
      emitState();
    };

    watch(() => values.value.taxId, emitState);

    emitState();

    return { tinType, tinOptions, values, fields, tipItem, onTinTypeInput, onFormValidation };
  },
});
